import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  type = 'website',
  schemaData,
  canonical
}) => {
  const siteTitle = 'genTechStaffing';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - IT Staffing & AI/ML Consulting Toronto`;
  const siteUrl = process.env.REACT_APP_BACKEND_URL?.replace('/api', '') || 'https://gentechstaffing.com';
  const canonicalUrl = canonical || siteUrl;

  // Default company schema
  const defaultSchema = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'genTechStaffing',
    description: 'Leading IT staffing and AI/ML consulting services in Toronto, Ontario. Expert RPA, ERP/CRM, generative AI implementation, and machine learning operations.',
    url: siteUrl,
    telephone: '(289) 633-4269',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Toronto',
      addressRegion: 'ON',
      addressCountry: 'CA'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 43.6532,
      longitude: -79.3832
    },
    areaServed: [
      {
        '@type': 'Country',
        name: 'Canada'
      },
      {
        '@type': 'Country',
        name: 'United States'
      }
    ],
    serviceType: [
      'IT Staffing Solutions',
      'AI Consulting',
      'Machine Learning Consulting',
      'Robotic Process Automation',
      'ERP Implementation',
      'CRM Solutions',
      'Generative AI Development',
      'MLOps Consulting',
      'LLM Implementation',
      'AI Governance',
      'Application Development'
    ],
    priceRange: '$$',
    openingHours: 'Mo-Fr 09:00-18:00'
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="en_CA" />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      
      {/* Schema.org structured data */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData || defaultSchema)}
      </script>
      
      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />
      <meta name="geo.region" content="CA-ON" />
      <meta name="geo.placename" content="Toronto" />
    </Helmet>
  );
};

export default SEO;